exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-btns[data-v-e435afee]{display:flex;justify-content:center;width:min(400px,100% - 4rem);text-align:center}@media screen and (min-width:1025px){.bottom-btns[data-v-e435afee]{margin-top:5rem auto 0 auto}}", ""]);

// exports
